export default __webpack_public_path__ + "static/media/DerbyHomeFirstCommunityResponseAdmissionAvoidanceDHUEMASv3.bb1770a7.jpeg";